export const albums = [
  {
    artist: 'Dean Blunt',
    album: 'Black Metal 2',
    embed:
      '<iframe src="https://open.spotify.com/embed/album/33xbAWdpX79o2YtXBiBWQv" width="100%" height="80" frameBorder="0" allowtransparency="true" allow="encrypted-media"></iframe>',
  },
  {
    artist: 'Bladee',
    album: 'The Fool',
  },
  {
    artist: 'Kanye West',
    album: 'Donda',
  },
  {
    artist: 'CFCF',
    album: 'Memoryland',
  },
  {
    artist: 'Squid',
    album: 'Bright Green Field',
  },

  {
    artist: 'Dry Cleaning',
    album: 'New Long Leg',
  },
  {
    artist: 'dltzk',
    album: 'Frailty',
  },

  {
    artist: 'Little Simz',
    album: 'Sometimes I Might Be Introvert',
  },
  {
    artist: 'Rx Papi, Gud',
    album: 'Foreign Exchange',
  },
  {
    artist: 'Faye Webster',
    album: 'I Know I’m Funny haha',
  },
  {
    artist: 'The Hellp',
    album: 'Enemy',
  },
  {
    artist: 'JPEGMafia',
    album: 'LP!',
  },

  {
    artist: 'Rochelle Jordan',
    album: 'Play With the Changes',
  },
  {
    artist: 'Injury Reserve',
    album: 'By the Time I get to Phoenix',
  },
  {
    artist: '파란노을 [Parannoul]',
    album: 'To See the Next Part of the Dream',
  },
  {
    artist: 'Tyler, The Creator',
    album: 'Call Me If You Get Lost',
  },
  {
    artist: 'Sufjan Stevens',
    album: "A Beginner's Mind",
  },
  {
    artist: 'RXKNephew',
    album: 'Slitherman Activated',
  },
  {
    artist: 'Lil Ugly Mane',
    album: 'Volcanic Bird Enemy and the Voiced Concern',
  },
  {
    artist: 'Spellling',
    album: 'The Turning Wheel',
  },
  {
    artist: 'Black Country, New Road',
    album: 'For the first time',
  },
  {
    artist: 'underscores',
    album: 'fishmonger',
  },
  {
    artist: 'Andy Stott',
    album: 'Never the Right Time',
  },
  {
    artist: 'Black Midi',
    album: 'Cavalcade',
  },
  {
    artist: 'Lana Del Rey',
    album: 'Blue Banisters',
  },

  {
    artist: 'Danny L Harle',
    album: 'Harlecore',
  },
  {
    artist: 'Shame',
    album: 'Drunk Tank Pink',
  },
  {
    artist: 'LSDXOXO',
    album: 'Dedicated 2 Disrespect',
  },

  {
    artist: 'Turnstile',
    album: 'Glow On',
  },
  {
    artist: 'Japanese Breakfast',
    album: 'Jubilee',
  },
];
